var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TemporaryRailwayMenuSettingCompanyFormModel } from '.';
import Defaults from '../Defaults';
var defaults = Defaults.MenuSetting;
var TemporaryRailwayMenuSettingStationTargetObjFormModel = /** @class */ (function () {
    function TemporaryRailwayMenuSettingStationTargetObjFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.railwayCompanies, railwayCompanies = _b === void 0 ? [] : _b, _c = _a.minutesAgo, minutesAgo = _c === void 0 ? defaults.minutesAgo : _c, _d = _a.visitCount, visitCount = _d === void 0 ? defaults.visitCount : _d, _e = _a.useS2, useS2 = _e === void 0 ? true : _e, _f = _a.radius, radius = _f === void 0 ? defaults.radius : _f, _g = _a.enableRadiusAutomation, enableRadiusAutomation = _g === void 0 ? defaults.enableRadiusAutomation : _g, _h = _a.enableBulkSetting, enableBulkSetting = _h === void 0 ? defaults.enableBulkSetting : _h;
        this.railwayCompanies = railwayCompanies.map(function (railwayCompany) {
            return TemporaryRailwayMenuSettingCompanyFormModel.assign(railwayCompany);
        });
        this.minutesAgo = minutesAgo;
        this.visitCount = visitCount;
        this.useS2 = useS2;
        this.radius = radius;
        this.enableRadiusAutomation = enableRadiusAutomation;
        this.originalEnableRadiusAutomation = enableRadiusAutomation;
        this.enableBulkSetting = enableBulkSetting;
    }
    TemporaryRailwayMenuSettingStationTargetObjFormModel.assign = function (data) {
        return new TemporaryRailwayMenuSettingStationTargetObjFormModel(data);
    };
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, company;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.railwayCompanies;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        company = _a[_i];
                        return [4 /*yield*/, company.init()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "countRailwayLines", {
        get: function () {
            return this.railwayCompanies
                .map(function (company) { return company.railwayLines.length; })
                .reduce(function (acc, value) { return acc + value; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "countTarget", {
        get: function () {
            return this.railwayCompanies
                .map(function (company) {
                return company.railwayLines
                    .map(function (line) { return line.stationIdAndNames.length; })
                    .reduce(function (acc, value) { return acc + value; }, 0);
            })
                .reduce(function (acc, value) { return acc + value; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.makeRailwayCompanies = function (selectedItemList) {
        var _this = this;
        var uniqueCompanyIds = Array.from(new Set(selectedItemList.map(function (item) { return item.companyId; })));
        // 削除
        this.railwayCompanies = this.railwayCompanies.filter(function (company) { return uniqueCompanyIds.indexOf(company.id) !== -1; });
        this.railwayCompanies = uniqueCompanyIds.map(function (companyId) {
            // 予めcompanyIdで絞る
            var filteredSelectedItemList = selectedItemList.filter(function (item) { return item.companyId === companyId; });
            var targetCompany = _this.railwayCompanies.find(function (company) { return company.id === companyId; });
            if (targetCompany) {
                targetCompany.updateLines(filteredSelectedItemList);
                return targetCompany;
            }
            else {
                return TemporaryRailwayMenuSettingCompanyFormModel.makeRailwayCompany(filteredSelectedItemList);
            }
        });
    };
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.setRadius = function (line) {
        var _a = line, companyId = _a.companyId, lineId = _a.lineId, radius = _a.radius;
        var company = this.railwayCompanies.find(function (company) { return company.id === companyId; });
        if (company) {
            company.setRadius(lineId, radius);
        }
    };
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.setRadiusToAllRadiusTarget = function (radius) {
        this.railwayCompanies.forEach(function (company) {
            return company.setRadiusToAllRadiusTarget(radius);
        });
    };
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.coerceUseS2State = function () {
        if (!this.availableUseS2) {
            this.useS2 = false;
        }
    };
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "availableUseS2", {
        get: function () {
            return this.enableRadiusAutomation || this.minutesAgo !== 0;
        },
        enumerable: false,
        configurable: true
    });
    TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype.setEnableRadiusAutomation = function (flag, isNew) {
        this.enableRadiusAutomation = flag;
        if (!flag) {
            this.useS2 = Defaults.MenuSetting.useLowQualityLocation;
            this.coerceUseS2State();
            this.enableBulkSetting = Defaults.MenuSetting.enableBulkSetting;
            if (!isNew && this.originalEnableRadiusAutomation) {
                var radius = Defaults.MenuSetting.radius;
                this.radius = radius;
                this.setRadiusToAllRadiusTarget(radius);
            }
        }
    };
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "validations", {
        get: function () {
            var minRadius = TemporaryRailwayMenuSettingStationTargetObjFormModel.MIN_RADIUS;
            return {
                advanced: {
                    required: function (value) {
                        return Boolean(value !== undefined && value !== '') || '入力して下さい';
                    },
                    overZero: function (value) { return Number(value) >= 0 || '0以上の数値を入力して下さい'; },
                    overOne: function (value) { return Number(value) >= 1 || '1以上の数値を入力して下さい'; },
                    overHundred: function (value) {
                        return Number(value) >= minRadius ||
                            "".concat(minRadius, "\u4EE5\u4E0A\u306E\u6570\u5024\u3092\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044");
                    },
                    integer: function (value) {
                        return Number.isInteger(Number(value)) || '整数で入力して下さい';
                    },
                    withinOneYear: function (value) {
                        return Number(value) <= 365 || '365日よりも前は指定できません';
                    },
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "emptyVisitCountViolation", {
        get: function () {
            return typeof this.visitCount === 'undefined';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "zeroVisitCountViolation", {
        get: function () {
            return this.visitCount < 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "emptyRadiusViolation", {
        get: function () {
            return (!this.enableRadiusAutomation &&
                this.enableBulkSetting &&
                typeof this.radius === 'undefined');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "lessRadiusViolation", {
        get: function () {
            return (!this.enableRadiusAutomation &&
                ((this.enableBulkSetting && (this.radius < 100 || this.radius > 10000)) ||
                    (!this.enableBulkSetting && this.lineRadiusViolation)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "lineRadiusViolation", {
        get: function () {
            return this.railwayCompanies.some(function (company) {
                return company.railwayLines.some(function (line) { return line.radius < 100 || line.radius > 10000; });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "emptyMinutesAgoViolation", {
        get: function () {
            return this.minutesAgo == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryRailwayMenuSettingStationTargetObjFormModel.prototype, "minusMinutesAgoViolation", {
        get: function () {
            return this.minutesAgo < 0;
        },
        enumerable: false,
        configurable: true
    });
    TemporaryRailwayMenuSettingStationTargetObjFormModel.MIN_RADIUS = 100;
    return TemporaryRailwayMenuSettingStationTargetObjFormModel;
}());
export { TemporaryRailwayMenuSettingStationTargetObjFormModel };
